<template>
  <div class="module-container group-sessions-container">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <div class="d-flex flex-row justify-content-start align-items-center">
        <div
          class="main-image-container bg-purple rounded d-flex justify-content-center align-items-center"
        >
          <img
            height="25"
            width="25"
            :src="require('../../assets/icons/people.svg')"
          />
        </div>
        <h3 class="mb-0 ml-3">Group Sessions</h3>
      </div>
      <div class="flex">
        <b-button
          class="smaller-button button-custom-blue"
          variant="primary"
          size="sm"
          @click="addGroup"
          ><i class="fa fa-plus mr-2" aria-hidden="true"></i> New
          Group</b-button
        >
      </div>
    </div>
    <div class="filters-container" ref="filtersContainer">
      <div
        class="d-flex flex-row justify-content-between align-items-center bg-light-gray min-width-fit-content"
      >
        <div class="d-flex flex-wrap align-items-center">
          <span class="ml-4 mr-3" style="font-size: 14px;"
            >Active filters:</span
          >
          <div
            v-if="filter.startDateFrom || filter.startDateTo"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Start date:
                <span class="color-filter"
                  >{{
                    filter.startDateFrom || filter.startDateTo
                      ? `(${
                          filter.startDateFrom
                            ? "From: " + formatDateOnly(filter.startDateFrom)
                            : ""
                        }${
                          filter.startDateFrom && filter.startDateTo
                            ? " - "
                            : ""
                        }${
                          filter.startDateTo
                            ? "To: " + formatDateOnly(filter.startDateTo)
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeStartDateFilter()"
              ></i>
            </div>
          </div>
          <div
            v-if="filter.endDateFrom || filter.endDateTo"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >End date:
                <span class="color-filter"
                  >{{
                    filter.endDateFrom || filter.endDateTo
                      ? `(${
                          filter.endDateFrom
                            ? "From: " + formatDateOnly(filter.endDateFrom)
                            : ""
                        }${
                          filter.endDateFrom && filter.endDateTo ? " - " : ""
                        }${
                          filter.endDateTo
                            ? "To: " + formatDateOnly(filter.endDateTo)
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeEndDateFilter()"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(u, uIndex) in filter.user"
            :key="u.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Provider: <span class="color-filter">{{ u.label }}</span></span
              >
              <i
                class="fa fa-times text-danger text-danger hover-pointer hover-text-almost-black"
                @click="removeUserFilter(uIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(u, uIndex) in filter.facilitators"
            :key="u.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Facilitator:
                <span class="color-filter">{{ u.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeFacilitatorFilter(uIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(c, cIndex) in filter.eoc"
            :key="c.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Patient: <span class="color-filter">{{ c.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeEocFilter(cIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(s, sIndex) in filter.status"
            :key="s.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3">
                Status: <span class="color-filter">{{ s.label }}</span>
              </span>
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeStatusFilter(sIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(s, sIndex) in filter.documentationStatus"
            :key="s.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3">
                Documentation Status:
                <span class="color-filter">{{ s.label }}</span>
              </span>
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeDocumentationStatusFilter(sIndex)"
              ></i>
            </div>
          </div>
          <div
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
            v-for="(s, sIndex) in filter.locations"
            :key="s.value"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Locations:
                <span class="color-filter">{{ s.label }}</span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeLocationFilter(sIndex)"
              ></i>
            </div>
          </div>
          <div
            v-if="filter.creationDateFrom || filter.creationDateTo"
            class="filter-value bg-white border pr-2 pt-1 pb-1 m-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <span class="mr-3"
                >Creation date:
                <span class="color-filter"
                  >{{
                    filter.creationDateFrom || filter.creationDateTo
                      ? `(${
                          filter.creationDateFrom
                            ? "From: " + formatDateOnly(filter.creationDateFrom)
                            : ""
                        }${
                          filter.creationDateFrom && filter.creationDateTo
                            ? " - "
                            : ""
                        }${
                          filter.creationDateTo
                            ? "To: " + formatDateOnly(filter.creationDateTo)
                            : ""
                        })`
                      : ""
                  }}
                </span></span
              >
              <i
                class="fa fa-times text-danger hover-pointer hover-text-almost-black"
                @click="removeCreationDateFilter()"
              ></i>
            </div>
          </div>
          <span
            v-if="hasFilters"
            class="clear-all-filters text-danger ml-2"
            style="font-size: 14px;"
            @click="clearAllFilters"
            >Clear all filters</span
          >
        </div>
        <div class="d-flex align-self-stretch align-items-center">
          <div class="align-self-stretch" style="padding: 9px 0px;">
            <div class="vertical-separator border-med-light-gray"></div>
          </div>
          <b-dropdown
            id="dropdown-form"
            text="Filters"
            ref="filterDropdown"
            class="container-main bg-light-gray"
            toggle-class="d-flex flex-row justify-content-between align-items-lg-center bg-transparent border-0 color-custom-dark-grey dropdown-menu-label"
            menu-class="container-filter-main-menu"
            toggle-tag="div"
            boundary="window"
            right
            @hide="onFilterHide"
          >
            <template #button-content>
              <div class="d-flex align-items-center mr-2">
                <i
                  class="fas fa-filter text-primary mr-2"
                  style="font-size: 15px;"
                  aria-hidden="true"
                ></i>
                <span style="font-size: 14px;">Filters</span>
              </div>
            </template>
            <b-dropdown-form class="px-2">
              <b-form-group label="Filter by:">
                <b-form-select
                  v-model="selectedFilter"
                  :options="
                    filterOptions.filter(option =>
                      !this.selectedLocation
                        ? option
                        : option.value !== 'locations'
                    )
                  "
                />
              </b-form-group>
              <date-range-filter
                v-if="selectedFilter == 'startDate'"
                v-model="filterStartDateRange"
                :filterWidth="filterWidth"
                label="Start Date"
                :key="'startDate'"
              />
              <date-range-filter
                v-if="selectedFilter == 'endDate'"
                v-model="filterEndDateRange"
                :filterWidth="filterWidth"
                label="End Date"
                :key="'endDate'"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'provider'"
                :label="'Provider'"
                :options="providerFacilitators"
                v-model="filter.user"
                :width="filterWidth"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'provider'"
                ref="providerFilter"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'facilitator'"
                :label="'Facilitators'"
                :options="providerFacilitators"
                v-model="filter.facilitators"
                :width="filterWidth"
                :showSearch="true"
                @on-search="updatePopper"
                @on-text-selection="updateTextSelection"
                :key="'facilitator'"
                ref="facilitatorFilter"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'patient'"
                :label="'Patients'"
                :options="clientOptions"
                v-model="filter.eoc"
                :width="filterPatientWidth"
                :showSearch="true"
                :async="true"
                :searching="searchingClients"
                @on-search="fetchClientOptions"
                :key="'patient'"
              >
                <template v-slot:item-option="{ itemOption, selected }">
                  <eoc-filter-option-template
                    :eoc="itemOption.data"
                    :selected="selected"
                  />
                </template>
              </multiple-select-filter>
              <multiple-select-filter
                v-if="selectedFilter == 'status'"
                :label="'Status'"
                :options="statuses"
                v-model="filter.status"
                :width="filterWidth"
                :key="'status'"
              />
              <multiple-select-filter
                v-if="selectedFilter == 'documentationStatus'"
                :label="'Documentation Status'"
                :options="documentationStatuses"
                v-model="filter.documentationStatus"
                :width="filterWidth"
                :key="'documentationStatus'"
              />
              <date-range-filter
                v-if="selectedFilter == 'creationDate'"
                v-model="filterCreationDateRange"
                :filterWidth="filterWidth"
                label="Creation Date"
                :key="'creationDate'"
              />
              <div v-if="selectedFilter == 'locations' && !selectedLocation">
                <multiple-select-filter
                  :label="'Locations'"
                  :options="locationOptions"
                  v-model="filter.locations"
                  :width="'250px'"
                  :showSearch="false"
                  :key="'locations'"
                  :id="'groupsIndexFilters-locations'"
                />
              </div>
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-0 w-100 d-flex flex-row justify-content-between">
      <div class="d-flex align-items-center" style="font-size: 19px;">
        <div class="">
          <a
            v-if="hasCurrentUserReportPermission('GroupSessions')"
            class="hover-pointer"
            style="font-size: 14px"
            @click="showReportRequestsModal = true"
          >
            <i class="fa fa-download"></i>
            <span class="ml-2 text-primary" style="font-size: 14px"
              >Export</span
            >
          </a>
        </div>
        <div
          v-if="
            currentUser &&
              !currentUser.onlyAccessAssignedPatients &&
              hasCurrentUserReportPermission('GroupSessions')
          "
          class="border-left border-med-light-gray pl-1 ml-1 mr-1"
          style="width: 1px; height: 19px"
        ></div>
        <vue-toggles
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          @click="changeAssignedToMEToggle()"
          :value="assignedToMe"
          height="20"
          width="30"
          checkedBg="#34C759"
          uncheckedBg="#FF6161"
        />
        <small
          v-if="currentUser && !currentUser.onlyAccessAssignedPatients"
          class="ml-2"
          >Show My Patients only</small
        >
      </div>
      <div class="d-flex flex-row justify-content-end align-items-center">
        <top-paginator
          :total="listTotal"
          :page="filter.page"
          :perPage="filter.pageSize"
          @change-page="changePage"
        />
      </div>
    </div>
    <div
      :style="
        `--document-list-filters-container-height:calc(${filtersContainerHeight}px);`
      "
    >
      <grid
        ref="grid"
        :groupFeature="false"
        :columns="columns"
        :store="gridConfig.store"
        :autoHeight="false"
        :data="items"
        :selectionMode="gridConfig.selectionMode"
        :columnLines="gridConfig.columnLines"
        :searchFeature="true"
        @storesort="listeners.storeSort"
        @paint="listeners.paint"
        @renderrows="hookDropdownButtons"
        @renderrow="hookDropdownButtons"
      ></grid>
    </div>

    <group-session-add-edit-modal
      v-if="showGroupEditor"
      v-model="showGroupEditor"
      :locationId="location"
      @onModify="onModifyAddGroup"
      :groupId="editGroup.id"
    />
    <group-session-notes-add-edit-modal
      v-if="showGroupNotesEditor"
      v-model="showGroupNotesEditor"
      :scheduleEvent="editGroup"
      @onModify="onModifyAddGroupSubmit"
    />
    <group-session-view-modal
      v-if="showGroupViewModal"
      v-model="showGroupViewModal"
      :groupId="editGroup.id"
      @onModify="onModifyAddGroupSubmit"
    />
    <report-request-index
      v-if="showReportRequestsModal"
      v-model="showReportRequestsModal"
      :reportFilters="exportFilter"
      reportName="GroupSessions"
    />
    <location-selector-group-session-modal
      v-if="showLocationSelectorModal"
      v-model="showLocationSelectorModal"
      @onHidden="showLocationSelectorModal = false"
      @selectLocation="
        location => {
          showLocationSelectorModal = false;
          selectLocation(location);
        }
      "
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Grid from "../../third_party/grid/Grid.vue";
import scheduleEventServer from "../../server/scheduleEvent";
import userServer from "../../server/user";
import eocServer from "../../server/eoc";
import {
  formatDate,
  formatDateOnly,
  formatEndDateSql,
  formatStartDateSql
} from "../../helpers/date";
import GroupSessionAddEditModal from "./GroupSessionAddEditModal.vue";
import GroupSessionNotesAddEditModal from "./GroupSessionNotesAddEditModal";
import EocFilterOptionTemplate from "../../views/EocFilterOptionTemplate";
import TopPaginator from "../controls/TopPaginator.vue";
import GroupSessionViewModal from "./GroupSessionViewModal.vue";
import ReportRequestIndex from "../report_request/ReportRequestIndex.vue";
import LocationSelectorGroupSessionModal from "./LocationSelectorGroupSessionModal.vue";
import catalogServer from "../../server/catalog";
export default {
  name: "GroupSessionIndex",
  components: {
    Grid,
    TopPaginator,
    GroupSessionAddEditModal,
    GroupSessionNotesAddEditModal,
    EocFilterOptionTemplate,
    ReportRequestIndex,
    GroupSessionViewModal,
    LocationSelectorGroupSessionModal
  },
  props: ["category", "showing"],
  data() {
    const self = this;
    return {
      list: [],
      listTotal: 0,
      selectedFilter: "startDate",
      filterOptions: [
        {
          value: "startDate",
          text: "Start date"
        },
        {
          value: "endDate",
          text: "End date"
        },
        {
          value: "provider",
          text: "Provider"
        },
        {
          value: "facilitator",
          text: "Facilitator"
        },
        {
          value: "patient",
          text: "Patient"
        },
        {
          value: "creationDate",
          text: "Creation date"
        },
        {
          value: "status",
          text: "Status"
        },
        {
          value: "documentationStatus",
          text: "Documentation Status"
        },
        {
          value: "locations",
          text: "Locations"
        }
      ],
      filter: {
        eoc: [],
        user: [],
        facilitators: [],
        status: [],
        documentationStatus: [],
        startDateFrom: null,
        startDateTo: null,
        endDateFrom: null,
        endDateTo: null,
        creationDateFrom: null,
        creationDateTo: null,
        page: 0,
        pageSize: 50,
        orderBy: "creationDate",
        orderByDescending: true,
        locations: []
      },
      listeners: {
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.filter.orderBy = field;
            self.filter.orderByDescending = !ascending;
            self.changePage(0);
          }
        },
        paint: paintEvent => {
          if (paintEvent.firstPaint) {
            window.bryntum.grid.EventHelper.on({
              element: paintEvent.source._element,
              delegate: "div.more-facilitators",
              click: async event => {
                event.stopPropagation();
                const groupId = event.srcElement.dataset.id;
                self.showAllFacilitators = {
                  ...self.showAllFacilitators,
                  [groupId]: true
                };
              },
              capture: true,
              thisObj: this
            });
            window.bryntum.grid.EventHelper.on({
              element: paintEvent.source._element,
              delegate: "div.less-facilitators",
              click: async event => {
                event.stopPropagation();
                const groupId = event.srcElement.dataset.id;
                self.showAllFacilitators = {
                  ...self.showAllFacilitators,
                  [groupId]: false
                };
              },
              capture: true,
              thisObj: this
            });
            window.bryntum.grid.EventHelper.on({
              element: paintEvent.source._element,
              delegate: "div.more-participants",
              click: async event => {
                event.stopPropagation();
                const groupId = event.srcElement.dataset.id;
                self.showAllParticipants = {
                  ...self.showAllParticipants,
                  [groupId]: true
                };
              },
              capture: true,
              thisObj: this
            });
            window.bryntum.grid.EventHelper.on({
              element: paintEvent.source._element,
              delegate: "div.less-participants",
              click: async event => {
                event.stopPropagation();
                const groupId = event.srcElement.dataset.id;
                self.showAllParticipants = {
                  ...self.showAllParticipants,
                  [groupId]: false
                };
              },
              capture: true,
              thisObj: this
            });
          }
        }
      },
      clientOptions: [],
      gridConfig: {
        minHeight: "20em",
        selectionMode: {
          row: true
        },
        columnLines: false,
        store: {
          sorters: [{ field: "creationDate", ascending: false }]
        }
      },
      showGroupEditor: false,
      showGroupNotesEditor: false,
      showGroupViewModal: false,
      showAllParticipants: {},
      showAllFacilitators: {},
      editGroup: {},
      users: [],
      facilitators: [],
      filterWidth: "250px",
      filterPatientWidth: "350px",
      searchingClients: false,
      filtersContainerHeight: 0,
      filterTextSelection: null,
      documentationStatuses: [
        {
          value: "Completed",
          label: "Completed"
        },
        {
          value: "Incomplete",
          label: "Incomplete"
        }
      ],
      showReportRequestsModal: false,
      showLocationSelectorModal: false,
      location: null,
      locationOptions: null
    };
  },
  methods: {
    ...mapActions("layout", [
      "showAlertSuccess",
      "toggleAssignToMeGroupSessionIndex"
    ]),
    ...mapActions("client", [
      "fetchScheduleEventStatuses",
      "fetchLevelsOfCare"
    ]),
    fetchInitialData() {
      this.fetchScheduleEventStatuses();
      this.searchGroups(false);
      this.fetchClientOptions("");
      this.getUsers();
      this.fetchUserLocations();
      this.fetchLevelsOfCare();
    },
    async fetchUserLocations() {
     const userLocations = await catalogServer.getUserLocations();
     this.locationOptions = userLocations.map(location => ({
       value: location.id,
       label: location.name,
       data: location
     }));
    },
    selectLocation(location) {
      this.location = location?.value;
      this.showGroupEditor = true;
    },
    changePage(page) {
      this.filter.page = page;
      this.searchGroups(false);
      this.scrollGridToTop();
    },
    scrollGridToTop() {
      const grid = document.querySelector(".group-sessions-container .b-grid");
      grid.scrollTop = 0;
    },
    async fetchClientOptions(search) {
      if (this.lastTimeout) {
        clearTimeout(this.lastTimeout);
        this.lastTimeout = null;
      }
      this.lastTimeout = setTimeout(async () => {
        if (!search || search.length == 0 || search.length >= 3) {
          this.searchingClients = true;
          const optionsResult = await eocServer.queryList(
            {
              searchPhrase: search,
              eocStatus:
                !search || search.length == 0 ? ["Active", "Pending"] : [],
              page: 1,
              pageSize: 50
            },
            {
              "Hide-Loading": true
            }
          );
          this.clientOptions = optionsResult.episodesOfCare.map(eoc => ({
            value: eoc.id,
            label: this.formatEocObj(eoc),
            data: eoc
          }));
          this.searchingClients = false;
        }
      }, 1000);
    },
    searchGroups(delayed = true) {
      if (delayed) {
        if (this.lastTimeout) {
          clearTimeout(this.lastTimeout);
          this.lastTimeout = null;
        }
        this.lastTimeout = setTimeout(async () => {
          this.fetchGroups();
        }, 1000);
      } else this.fetchGroups();

      this.showResults = true;
    },
    changeAssignedToMEToggle() {
      this.toggleAssignToMeGroupSessionIndex();
      this.fetchGroups();
    },
    async fetchGroups() {
      const result = await scheduleEventServer.queryPaginatedImproved({
        startDateFrom: formatStartDateSql(this.filter.startDateFrom),
        startDateTo: formatEndDateSql(this.filter.startDateTo),
        endDateFrom: formatStartDateSql(this.filter.endDateFrom),
        endDateTo: formatEndDateSql(this.filter.endDateTo),
        userIds: this.filter.user.map(u => u.value),
        facilitatorIds: this.filter.facilitators.map(u => u.value),
        episodeOfCareIds: this.filter.eoc.map(e => e.value),
        statusId: this.filter.status.map(e => e.value),
        documentationStatus: this.filter.documentationStatus.map(e => e.value),
        creationDateFrom: formatStartDateSql(this.filter.creationDateFrom),
        creationDateTo: formatEndDateSql(this.filter.creationDateTo),
        page: this.filter.page,
        pageSize: this.filter.pageSize,
        orderBy: this.filter.orderBy,
        orderByDescending: this.filter.orderByDescending,
        types: ["GroupSession"],
        assignedToMe: this.assignedToMe,
        locationIds: this.filter.locations.map(location => location.value)
      });
      this.list = result.scheduleEvents;
      this.listTotal = result.count;
    },
    onModifyAddGroup() {
      this.showGroupEditor = false;
      this.editGroup = {};
      this.searchGroups(false);
    },
    onModifyAddGroupSubmit() {
      this.showGroupNotesEditor = false;
      this.editGroup = {};
      this.searchGroups(false);
    },
    addGroup() {
      this.editGroup = {};
      if (this.selectedLocation) {
        this.showGroupEditor = true;
      } else {
        this.showLocationSelectorModal = true;
      }
    },
    removeCreationDateFilter() {
      this.filter.creationDateFrom = null;
      this.filter.creationDateTo = null;
    },
    removeStartDateFilter() {
      this.filter.startDateFrom = null;
      this.filter.startDateTo = null;
    },
    removeEndDateFilter() {
      this.filter.endDateFrom = null;
      this.filter.endDateTo = null;
    },
    removeUserFilter(index) {
      const newValue = [...this.filter.user];
      newValue.splice(index, 1);
      this.filter.user = newValue;
    },
    removeFacilitatorFilter(index) {
      const newValue = [...this.filter.facilitators];
      newValue.splice(index, 1);
      this.filter.facilitators = newValue;
    },
    removeEocFilter(index) {
      const newValue = [...this.filter.eoc];
      newValue.splice(index, 1);
      this.filter.eoc = newValue;
    },
    removeStatusFilter(index) {
      const newValue = [...this.filter.status];
      newValue.splice(index, 1);
      this.filter.status = newValue;
    },
    removeLocationFilter(index) {
      const newValue = [...this.filter.locations];
      newValue.splice(index, 1);
      this.filter.locations = newValue;
    },
    removeDocumentationStatusFilter(index) {
      const newValue = [...this.filter.documentationStatus];
      newValue.splice(index, 1);
      this.filter.documentationStatus = newValue;
    },
    async getUsers() {
      const users = await userServer.getMinimalUsers();
      this.users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user),
        data: user
      }));
    },
    clearAllFilters() {
      this.filter.eoc = [];
      this.filter.user = [];
      this.filter.facilitators = [];
      this.filter.status = [];
      this.filter.documentationStatus = [];
      this.filter.creationDateFrom = null;
      this.filter.creationDateTo = null;
      this.filter.startDateFrom = null;
      this.filter.startDateTo = null;
      this.filter.endDateFrom = null;
      this.filter.endDateTo = null;
    },
    computeHeights() {
      setTimeout(() => {
        const filtersContainerHeight = this.$refs.filtersContainer.clientHeight;
        this.filtersContainerHeight = filtersContainerHeight;
      }, 0);
    },
    updatePopper() {
      this.$refs.filterDropdown.updatePopper();
    },
    onFilterHide(event) {
      if (this.filterTextSelection) {
        if (this.filterTextSelection) event.preventDefault();
        this.$refs.providerFilter.highlightText();
        this.$refs.facilitatorFilter.highlightText();
        this.filterTextSelection = null;
      }
    },
    updateTextSelection(textSelection) {
      this.filterTextSelection = textSelection;
    },
    orderByValueForReport(orderBy) {
      if (orderBy === "creationDate") return "Creation Date";

      if (orderBy === "startDate") return "Start Date Time";

      if (orderBy === "endDate") return "End Date Time";

      if (orderBy === "topic") return "Topic";

      if (orderBy === "facilitators") return "Facilitator";

      if (orderBy === "participants") return "Participants";

      return "";
    }
  },
  computed: {
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation,
      currentUser: state => state.currentUser,
      assignedToMe: state => state.assignedToMeGroupSessionIndex
    }),
    ...mapState("client", {
      statuses: state =>
        state.scheduleEventStatuses.map(status => ({
          value: status.id,
          label: status.name,
          data: status
        }))
    }),
    ...mapGetters("layout", [
      "hasCurrentUserReportPermission",
      "canEditChargedEvents"
    ]),
    providerFacilitators() {
      return this.users.filter(u => u.data.providerInfo);
    },
    filterStartDateRange: {
      get() {
        return {
          dateFrom: this.filter.startDateFrom,
          dateTo: this.filter.startDateTo
        };
      },
      set(newValue) {
        this.filter.startDateFrom = newValue.dateFrom;
        this.filter.startDateTo = newValue.dateTo;
      }
    },
    filterEndDateRange: {
      get() {
        return {
          dateFrom: this.filter.endDateFrom,
          dateTo: this.filter.endDateTo
        };
      },
      set(newValue) {
        this.filter.endDateFrom = newValue.dateFrom;
        this.filter.endDateTo = newValue.dateTo;
      }
    },
    filterCreationDateRange: {
      get() {
        return {
          dateFrom: this.filter.creationDateFrom,
          dateTo: this.filter.creationDateTo
        };
      },
      set(newValue) {
        this.filter.creationDateFrom = newValue.dateFrom;
        this.filter.creationDateTo = newValue.dateTo;
      }
    },
    items() {
      return this.list.map(item => {
        const docHeight = 28;
        const margin = 8;
        const documentsCount =
          this.showAllParticipants[item.id] && this.showAllFacilitators[item.id]
            ? item.episodesOfCare.length > item.facilitators.length
              ? item.episodesOfCare.length
              : item.facilitators.length
            : this.showAllParticipants[item.id]
            ? item.episodesOfCare.length
            : this.showAllFacilitators[item.id]
            ? item.facilitators.length
            : 3;
        const rowHeight = documentsCount * docHeight + margin * 2;
        return { ...item, rowHeight };
      });
    },
    columns() {
      const self = this;
      let columns = [];
      columns.push({
        text: "Start Date Time",
        field: "startDate",
        type: "template",
        width: 160,
        editor: false,
        template: data =>
          data.record.data.allDay
            ? formatDateOnly(data.record.data.startDateTime) + " All day"
            : data.record.data.startDateTime
            ? formatDate(data.record.data.startDateTime)
            : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "End Date Time",
        field: "endDate",
        type: "template",
        width: 160,
        editor: false,
        template: data =>
          data.record.data.endDateTime
            ? formatDate(data.record.data.endDateTime)
            : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      if (this.selectedLocation == null) {
        columns.push({
          text: "Location",
          field: "location",
          type: "template",
          flex: 1,
          editor: false,
          template: data =>
            data.record.data.location ? data.record.data.location : "",
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        });
      }
      columns.push({
        text: "Topic",
        field: "topic",
        type: "template",
        flex: 1,
        editor: false,
        template: data =>
          data.record.data.topic ? data.record.data.topic : "",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Provider",
        field: "provider",
        type: "template",
        flex: 1,
        editor: false,
        template: data =>
          data.record.data.users.length > 0
            ? this.formatUser(data.record.data.users[0])
            : "No provider selected",
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Facilitators",
        field: "facilitators",
        type: "template",
        flex: 1,
        editor: false,
        template: data => {
          return data.record.data.facilitators
            ? `<div class="w-100">${data.record.data.facilitators
                .slice(
                  0,
                  self.showAllFacilitators[data.record.data.id]
                    ? data.record.data.facilitators.length
                    : Math.min(data.record.data.facilitators.length, 2)
                )
                .map(f => {
                  const formattedFacilitator = `<span class="text-secondary ml-1">${this.formatUser(
                    f
                  )}</span>`;
                  return `<div class="px-2 py-1 d-flex w-100 justify-content-start align-items-center">${formattedFacilitator}</div>`;
                })
                .join("")}
                ${
                  data.record.data.facilitators.length > 2 &&
                  !self.showAllFacilitators[data.record.data.id]
                    ? `<div class="more-facilitators px-2 py-1 d-flex w-100 justify-content-start align-items-center text-primary cursor-pointer" data-id="${
                        data.record.data.id
                      }">+${data.record.data.facilitators.length - 2} more...`
                    : ""
                }
                ${
                  data.record.data.facilitators.length > 2 &&
                  self.showAllFacilitators[data.record.data.id]
                    ? `<div class="less-facilitators px-2 py-1 d-flex w-100 justify-content-start align-items-center text-primary cursor-pointer" data-id="${data.record.data.id}">Less...`
                    : ""
                }
                </div>`
            : "";
        },
        sortable: false
      });
      columns.push({
        text: "Creation Date",
        field: "creationDate",
        type: "template",
        width: 160,
        editor: false,
        template: data => formatDate(data.record.data.creationDate),
        sortable() {
          return self.filter.orderByDescending ? -1 : 1;
        }
      });
      columns.push({
        text: "Participants",
        field: "participants",
        type: "template",
        flex: 1,
        editor: false,
        template: data => {
          return data.record.data.episodesOfCare
            ? `<div class="w-100">${data.record.data.episodesOfCare
                .slice(
                  0,
                  self.showAllParticipants[data.record.data.id]
                    ? data.record.data.episodesOfCare.length
                    : Math.min(data.record.data.episodesOfCare.length, 2)
                )
                .map(f => {
                  const patientName = this.formatClient(
                    f.episodeOfCare.patient.firstName,
                    f.episodeOfCare.patient.middleName,
                    f.episodeOfCare.patient.preferredName,
                    f.episodeOfCare.patient.lastName
                  );
                  const iconClass =
                    "ml-1 fa-file " +
                    (f.documentationCompleted ? "text-success" : "text-danger");
                  const docIcon = `<i class="fa ${iconClass}"></i>`;
                  const badge = `<span class="badge text-white" style="background-color: ${
                    f.scheduleEventStatus.color
                  }; min-width: 21px;">
                    ${f.scheduleEventStatus.name
                      .replace(/\s/g, "")
                      .replace(/[a-z]/g, "")}
                  </span>`;
                  const formattedName = `<span class="text-secondary ml-1">${patientName}</span>`;
                  return `<div class="px-2 py-1 d-flex w-100 justify-content-start align-items-center">${badge}${docIcon}${formattedName}</div>`;
                })
                .join("")}
                ${
                  data.record.data.episodesOfCare.length > 2 &&
                  !self.showAllParticipants[data.record.data.id]
                    ? `<div class="more-participants px-2 py-1 d-flex w-100 justify-content-start align-items-center text-primary cursor-pointer" data-id="${
                        data.record.data.id
                      }">+${data.record.data.episodesOfCare.length - 2} more...`
                    : ""
                }
                ${
                  data.record.data.episodesOfCare.length > 2 &&
                  self.showAllParticipants[data.record.data.id]
                    ? `<div class="less-participants px-2 py-1 d-flex w-100 justify-content-start align-items-center text-primary cursor-pointer" data-id="${data.record.data.id}">Less...`
                    : ""
                }
                </div>`
            : "";
        },
        sortable: false
      });
      columns.push({
        text: "Tools",
        type: "action",
        cellCls: "pointer-cell",
        field: "action",
        align: "right",
        width: 80,
        actions: [
          {
            tooltip: "View",
            renderer: ({ record }) => {
              return record.data.episodesOfCare
                .map(p => p.linkedDocuments)
                .reduce((acc, val) => acc.concat(val), [])
                .filter(d => d.document).length > 0
                ? `<i class="fa fa-search-plus color-custom-dark-grey hover-text-primary b-action-item grid-action-icon"></i>`
                : ``;
            },
            onClick: ({ record }) => {
              this.editGroup.id = record.id;
              this.showGroupViewModal = true;
            }
          },
          {
            tooltip: "More",
            renderer: ({ record }) => {
              let options = [
                {
                  content: "Edit",
                  callback: () => {
                    this.editGroup.id = record.id;
                    this.showGroupEditor = true;
                  }
                },
                {
                  content: "Delete",
                  callback: () => {
                    this.$dialog
                      .alert(
                        {
                          title: "Are you sure you want to delete this record?"
                        },
                        {
                          view: "confirm-delete",
                          checkbox: true,
                          checkboxBody:
                            "Do you want to delete the documents associated with this event?"
                        }
                      )
                      .then(async dialog => {
                        let result = await scheduleEventServer.delete(
                          record.id,
                          dialog.data
                        );
                        if (result.errorCode) {
                          this.$dialog.alert("Error: " + result.message);
                        } else {
                          this.searchGroups(false);
                          this.showAlertSuccess();
                        }
                      });
                  }
                }
              ];
              if (record.data.episodesOfCare.length > 0) {
                options.unshift({
                  content: "Group Notes",
                  callback: () => {
                    this.editGroup = record.data;
                    this.showGroupNotesEditor = true;
                  }
                });
              }
              return this.createDropdownButton({
                items: options.filter(option => {
                  if (
                    record.billingInfo?.encounterSubmited &&
                    !this.canEditChargedEvents
                  ) {
                    if (
                      option.content !== "Edit" &&
                      option.content !== "Delete"
                    ) {
                      return true;
                    }
                    return false;
                  }
                  return true;
                })
              });
            }
          }
        ]
      });
      return columns;
    },
    hasFilters() {
      return (
        this.filter.creationDateFrom ||
        this.filter.creationDateTo ||
        this.filter.startDateFrom ||
        this.filter.startDateTo ||
        this.filter.endDateFrom ||
        this.filter.endDateTo ||
        this.filter.user.length > 0 ||
        this.filter.facilitators.length > 0 ||
        this.filter.eoc.length > 0 ||
        this.filter.status.length > 0 ||
        this.filter.documentationStatus.length > 0
      );
    },
    exportFilter() {
      return {
        startDateFrom: this.filter.startDateFrom,
        startDateTo: this.filter.startDateTo,
        endDateFrom: this.filter.endDateFrom,
        endDateTo: this.filter.endDateTo,
        facilitatorIds: this.filter.facilitators.map(u => u.value),
        providerIds: this.filter.user.map(u => u.value),
        patientIds: this.filter.eoc.map(e => e.value),
        StatusIds: this.filter.status.map(e => e.value),
        DocumentationStatus: this.filter.documentationStatus.map(s => {
          if (s.value == "Completed") return 1;
          if (s.value == "Incomplete") return 0;
          return 0;
        }),
        creationDateFrom: this.filter.creationDateFrom,
        creationDateTo: this.filter.creationDateTo,
        orderBy: this.orderByValueForReport(this.filter.orderBy),
        sort: this.filter.orderByDescending ? "Descending" : "Ascending",
        locationIds: [this.selectedLocation],
        assignedToMe: this.assignedToMe
      };
    }
  },
  watch: {
    showing: {
      handler: function(newValue) {
        if (newValue) {
          this.filter.page = 0;
          this.fetchInitialData();
          this.computeHeights();
        }
      }
    },
    "filter.creationDateFrom": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.creationDateTo": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.startDateFrom": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.startDateTo": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.endDateFrom": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.endDateTo": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.user": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.facilitators": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.eoc": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.status": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.documentationStatus": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    "filter.locations": function() {
      this.filter.page = 0;
      this.searchGroups();
      this.computeHeights();
    },
    selectedFilter: function() {
      this.$refs.filterDropdown.updatePopper();
    }
  }
};
</script>

<style scoped>
.container-main {
  height: 45px;
}
.container-main:hover {
  cursor: pointer;
}
.b-dropdown-form:focus {
  outline: none !important;
}
.filter-values {
  width: 250px;
}
.filter-value {
  min-width: 100px;
  height: 29px;
  color: #a6a6a6;
  font-size: 14px;
  padding-left: 10px;
}
.filter-value-delete {
  position: absolute;
  top: -8px;
  right: -8px;
}
.filter-value-delete:hover {
  cursor: pointer;
}
.clear-all-filters:hover {
  cursor: pointer;
}
.filter-values {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.filter-title {
  font-size: 16px;
}
.filters-container >>> .container-filter-main-menu {
  min-width: 250px;
  left: -17px;
}
.vertical-separator {
  width: 1px;
  border-left: 1px solid;
  height: 100%;
}
.color-filter {
  color: #909db8;
}
.group-sessions-container >>> .b-grid-container .b-container {
  max-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  );
  min-height: calc(
    100vh - var(--document-list-filters-container-height) - 240px
  ) !important;
}
</style>
<style>
.container-main-menu {
  width: auto;
}
.b-calendar-grid-help {
  display: none;
}
.b-calendar .b-calendar-grid {
  border: none;
}
.b-calendar .b-calendar-inner {
  min-width: 200px !important;
}
</style>
